import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Dialog, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { TopUpWithdrawTxType } from 'src/type/topup-withdraw';
import { TransactionType, TransactionStatus } from 'src/type/transaction';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import * as Yup from 'yup';
import useCurrentDateTime from 'src/hooks/use-current-date-time';
import { txAction } from './utils';

const Schema = Yup.object().shape({
  reason: Yup.string(),
});

const defaultValues = {
  reason: '',
};

type Props = {
  open: boolean;
  onClose: VoidFunction;
  topUpWithdrawTx: TopUpWithdrawTxType;
  handleReload: VoidFunction;
};

export default function TopupWithdrawRejectDialog({
  open,
  onClose,
  topUpWithdrawTx,
  handleReload,
}: Props) {
  const currentDateTime = useCurrentDateTime();

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      if (topUpWithdrawTx.status !== TransactionStatus.PENDING) {
        throw new Error('ไม่สามารถอัพเดทข้อมูลได้');
      }

      let endpoint: (id: string) => string;
      if (topUpWithdrawTx.type === TransactionType.TOPUP_CREDIT) {
        endpoint = endpoints.transactions.rejectTopup;
      } else if (topUpWithdrawTx.type === TransactionType.WITHDRAW_CREDIT) {
        endpoint = endpoints.transactions.rejectWithdraw;
      } else {
        throw new Error('ไม่สามารถอัพเดทข้อมูลได้');
      }

      await axios.post(endpoint(topUpWithdrawTx.id), {
        note: data.reason,
        currentDateTime,
      });
      handleReload();
      beforeClose();
      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
    } catch (error) {
      toastError(error);
    }
  });

  const beforeClose = () => {
    reset(defaultValues);
    onClose();
  };

  return (
    <Dialog open={open} onClose={beforeClose} maxWidth="sm" fullWidth>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>ปฏิเสธรายการ{txAction(topUpWithdrawTx?.type)}</DialogTitle>

        <DialogContent>
          <RHFTextField
            multiline
            rows={3}
            name="reason"
            placeholder="หมายเหตุ"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={beforeClose} disabled={isSubmitting}>
            ยกเลิก
          </Button>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
            ดำเนินการต่อ
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
